import React from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import Name from '../../components/Name/Name'
import Badges from '../../components/Badges/Badges'
import Youreko from '../../components/Youreko/Youreko'
import ReviewsFlag from '../../components/ReviewsFlag/ReviewsFlag'

const DefaultHeadingSection = ({ energyPDF, name, badgesOptions, reviewsFlagOptions }) => {
  return (
    <>
      <ErrorBoundary>
        <Badges {...badgesOptions} energyPDF={energyPDF} />
        <Youreko />
      </ErrorBoundary>
      <ErrorBoundary>
        <Name productName={name} />
      </ErrorBoundary>
      <ErrorBoundary>
        <ReviewsFlag {...reviewsFlagOptions} />
      </ErrorBoundary>
    </>
  )
}

DefaultHeadingSection.propTypes = {
  name: PropTypes.string,
  badgesOptions: PropTypes.object,
  reviewsFlagOptions: PropTypes.object,
  energyPDF: PropTypes.string
}

export default DefaultHeadingSection
